export const dateTypeEventMap = {
    startDate: 'calendar_departure',
    endDate: 'calendar_arrival',
};
